"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TableHeaderContextProvider: ()=>TableHeaderContextProvider,
    useIsInTableHeader: ()=>useIsInTableHeader
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const tableHeaderContext = /*#__PURE__*/ _react.createContext(undefined);
const tableHeaderContextDefaultValue = '';
const TableHeaderContextProvider = tableHeaderContext.Provider;
const useIsInTableHeader = ()=>_react.useContext(tableHeaderContext) === tableHeaderContextDefaultValue; //# sourceMappingURL=tableHeaderContext.js.map

//# sourceMappingURL=tableHeaderContext.js.map